import base from './base';
import data from './data/certification';

const certificationApi = {};

certificationApi.checkIdentityNo = (val) => {
  console.log(val);
  return base.fetch(data.checkIdentityNo, 300);
};
certificationApi.checkBankAccount = (val) => {
  console.log(val);
  return base.fetch(data.checkBankAccount, 300);
};

export default {
  ...certificationApi,
};
